import type { BuildExecutionCopyTextParams } from './interfaces/buildExecutionCopyTextParams.interface'

export const buildExecutionCopyText = ({ isTryItMode, allVariableCode, code }: BuildExecutionCopyTextParams): string =>
  isTryItMode ? [allVariableCode, code].join('\n') : code
